import { Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutUnvoidOrderPrompt extends Layout {
    labelAreYouSureYouWantToUnvoidThisOrder?: Label;
    panelReason: Panel;
}
